import { useState, useEffect } from "react";
import moment from "moment";
import "moment/locale/ru";

import { ScheduleToggler } from "../../../Schedule/ScheduleSwitchers/ScheduleToggler/ScheduleToggler.jsx";
import { FetchService } from "../../../../API/FetchService.js";
import { FetchComponent } from "../../../FetchComponent/FetchComponent.jsx";
import { ScheduleButtonMobile } from "../../../Schedule/ScheduleButtonMobile/ScheduleButtonMobile.jsx";

import styles from "./CabinetScheduleStudent.module.css";

const LessonList = ({ data }) => {
  if (data.length) {
    return (
      <div className={styles.lessonsWrapper}>
        {data.map((lesson, index) => {
          return <ScheduleButtonMobile key={index} data={lesson} student />;
        })}
      </div>
    );
  } else {
    return <ScheduleButtonMobile plug />;
  }
};

export const CabinetScheduleStudent = ({ user }) => {
  const { ref, role } = user;
  const [responseData, setResponseData] = useState({
    data: [],
    loading: true,
    error: false,
  });
  const { data, loading, error } = responseData;
  const [week, setWeek] = useState(0);
  const [date, setDate] = useState({
    today: moment(),
    startOfWeek: moment().startOf("week"),
    endOfWeek: moment().endOf("week"),
  });

  useEffect(() => {
    setResponseData((prev) => {
      return { ...prev, loading: true };
    });
    new FetchService({ ref, role, week })
      .getPersonLessons()
      .then(({ data }) => {
        setResponseData((prev) => {
          return { ...prev, data };
        });
      })
      .catch(() => {
        setResponseData((prev) => {
          return { ...prev, error: true };
        });
      })
      .finally(() => {
        setResponseData((prev) => {
          return { ...prev, loading: false };
        });
      });
  }, [ref, role, week]);

  useEffect(() => {
    const startOfWeek = date.today.clone().startOf("week");
    const endOfWeek = date.today.clone().endOf("week");
    setDate({ ...date, startOfWeek, endOfWeek });
  }, [date.today]);

  return (
    <>
      <h1 className="mb-2 text-center">Расписание занятий</h1>
      <ScheduleToggler
        classNames="col-12 mx-auto mb-2 text-center"
        title="Выберите даты"
        leftClickHandler={() => {
          setWeek((prev) => prev - 1);
          setDate({
            ...date,
            today: date.today.clone().subtract(7, "days"),
          });
        }}
        rightClickHandler={() => {
          setWeek((prev) => prev + 1);
          setDate({ ...date, today: date.today.clone().add(7, "days") });
        }}
      >
        <span>{date.startOfWeek.format("D MMMM")}</span>
        <span>{date.endOfWeek.format("D MMMM")}</span>
      </ScheduleToggler>
      <FetchComponent
        keyAnimation={week + loading.toString()}
        loading={loading}
        error={error}
        heightContainer="20vh"
      >
        <LessonList data={data} />
      </FetchComponent>
    </>
  );
};
